import * as React from "react";
const SvgUpload24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 22,
        fill: "black",
        viewBox: "0 0 20 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M16.207 6.793 10 .586 3.793 6.793l1.414 1.414L9 4.414V16h2V4.414l3.793 3.793 1.414-1.414ZM2 14H0v8h20v-8h-2v6H2v-6Z",
      clipRule: "evenodd"
    })
  );
export default SvgUpload24Px;
